import React, { useState, useEffect } from "react";
import NavHeader from "../../Common/NavHeader";
import BreadCrumb from "../../Common/BreadCrumb";
import Paginator from "../../Common/Paginator";
import { getMenuMix, changeMenuMixCategory, searchMenuMix } from "../api";
import useAppStore from "../../../store/global";
import { Spinner } from "react-bootstrap";
import { useParams, useLocation, useSearchParams } from "react-router-dom";
import MenuMixTable from "./MenuMixTable";
import { toast, ToastContainer } from "react-toastify";
import { Form, FormControl, InputGroup, Button } from "react-bootstrap";
import { Search } from "react-bootstrap-icons";
import ManualClassificationModal from "../../Common/ExportModal";

export default function MenuMixHome() {
  const [searchParams, setSearchParams] = useSearchParams();
  const pos_category = searchParams.get("pos_category");

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const restName = queryParams.get("restaurant_name");

  const [reports, setReports] = useState([]);
  const { loading, setLoading, pageSize } = useAppStore();
  const [approveLoading, setApproveLoading] = useState(false);
  const [pageNum, setPageNum] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [searchTerm, setSearchTerm] = useState(null);
  const { id } = useParams();
  const [showModal, setShowModal] = useState(false);

  const fetchData = (pageNum, id) => {
    setLoading(true);
    const apiCall =
      searchTerm && searchTerm.length > 0 ? searchMenuMix : getMenuMix;
    let filters = null;
    if (pos_category) {
      filters = {
        pos_category_name: pos_category,
      };
    } else {
      filters = {};
    }
    apiCall({
      restaurant_id: id,
      pageNum: pageNum,
      pageSize: pageSize,
      naame: searchTerm,
      filters,
    })
      .then((data) => {
        if (searchTerm && searchTerm.length > 0) {
          setReports(data.results);
        } else {
          setReports(data.menu_mix);
          setTotalPages(data.totalPages);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log("error", err);
        setLoading(false);
      });
  };

  const fetchMenuMix = () => {
    fetchData(pageNum, id);
  };

  const handleSearch = (searchTerm) => {
    fetchData(pageNum, id);
  };

  const handleCategoryChange = (body) => {
    setApproveLoading(true);
    changeMenuMixCategory(body)
      .then((data) => {
        toast.success(data.message);
        setApproveLoading(false);
        fetchMenuMix();
      })
      .catch((err) => {
        setApproveLoading(false);
        toast.error(err.message);
      });
  };

  useEffect(() => {
    fetchData(pageNum, id);
  }, [pageNum, searchTerm, pos_category]);

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const pos_category_choices = [
    "Liquor",
    "Open Catering Food",
    "Open Food",
    "Open Liquor",
    "Open N/A Bev",
    "Open NA Beverage",
    "Sides",
    "a la carte",
    "add ons",
    "al la carte",
    "alcohol",
    "appetizers",
    "apps",
    "bar specials",
    "beer",
    "beverages",
    "beverages online",
    "bigsubs",
    "bottled beer",
    "bottled drinks",
    "bowls",
    "boxed lunch",
    "brunch",
    "build your own bowls online",
    "burger night",
    "burgers",
    "byob",
    "byob (in store only)",
    "calzones",
    "caterapps",
    "caterdesserts",
    "caterdinners",
    "catering",
    "catering day of ringing",
    "caterpasta",
    "caterplatter",
    "catersalads",
    "catervegetables",
    "chickendinners",
    "classic cocktails",
    "classics",
    "clothing",
    "cocktails",
    "coffee + espresso",
    "coldsandwiches",
    "combos",
    "deposits",
    "dessert",
    "desserts",
    "dinner for 2",
    "disposables",
    "draft beer",
    "drink",
    "drinks",
    "eggplantdinners",
    "entrees",
    "entrées",
    "extra sauces $",
    "fall cocktails",
    "fall specials",
    "featured cocktails",
    "fixins",
    "flatbread",
    "flatbreads",
    "food",
    "food modifiers",
    "fountain drinks",
    "gift cards",
    "goodies",
    "goodies online",
    "grandmapizza",
    "gumbo night",
    "handhelds",
    "holiday cocktails",
    "hotsandwiches",
    "ingredient",
    "invoicing autogenerated - do not edit",
    "italian night",
    "kid's menu",
    "kids",
    "kidsmenu",
    "lighter side na",
    "liquor",
    "meze",
    "misc",
    "mixed grills",
    "non-alcoholic",
    "open",
    "open beer",
    "open catering food",
    "open food",
    "open liquor",
    "open n/a bev",
    "open na beverage",
    "open wine",
    "other drinks",
    "oyster shooters",
    "paninis",
    "pasta",
    "phyllo pies",
    "pizza",
    "platters",
    "platters & pita wraps",
    "prime rib night",
    "raw bar",
    "retail",
    "salads",
    "salads & soup",
    "sandwiches",
    "seafood night",
    "seafooddinners",
    "shooters",
    "shots",
    "side dishes",
    "side meats",
    "side protein",
    "side proteins",
    "sides",
    "sides + extras",
    "signature bowls",
    "snacks",
    "soups",
    "specials",
    "specialty cocktails",
    "spreads",
    "st. patrick's day",
    "starters",
    "steamer bar",
    "strombolis",
    "sugar",
    "sweets",
    "taco night",
    "tacos",
    "the meats",
    "this & that",
    "uncategorized",
    "vealdinners",
    "wine",
    "wines",
    "wraps",
  ];

  return (
    <>
      <NavHeader view="scrapper" />
      <div className="mx-2 mx-md-4" style={{ marginTop: "100px" }}>
        <BreadCrumb text={`Restaurants > ${restName} > Menu Mix`} />
        <Form className="mt-3 mb-3 w-100 d-flex justify-content-between">
          <Form.Group controlId="searchBar" className="d-flex w-50">
            <InputGroup>
              <FormControl
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <Button variant="outline-secondary">
                <Search />
              </Button>
            </InputGroup>
          </Form.Group>
          {/* <Button variant="primary" onClick={handleShowModal}>
            Bulk Approve
          </Button> */}
        </Form>

        {loading ? (
          <div className="d-flex justify-content-center align-items-center">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <>
            <MenuMixTable
              approveLoading={approveLoading}
              reports={reports}
              setReports={setReports}
              handleCategoryChange={handleCategoryChange}
              restaurant_id={id}
            />
            {searchTerm == null && (
              <Paginator
                pageNum={pageNum}
                setPageNum={setPageNum}
                totalPages={totalPages}
              />
            )}
            <ManualClassificationModal
              showModal={showModal}
              handleCloseModal={handleCloseModal}
            />
          </>
        )}
      </div>
      <ToastContainer />
    </>
  );
}
